import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {InvestmentOfferTypeSlug} from "../../../investment_offer/constants/investment_offer_constants";

/**
 * Returns true when the user is on the holiday (apartamenty wakacyjne) listing view.
 * Use for conditional UI (e.g. hiding recent filters, different copy).
 */
export const useOfferListingHolidayView = (): boolean => {
    const investmentCategory = useSelector((state: IRPStore) => state.investmentOffer?.categories?.category);
    return investmentCategory === InvestmentOfferTypeSlug.HOLIDAY;
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {InvestmentOfferTypeSlug} from "../../../investment_offer/constants/investment_offer_constants";

/**
 * Returns true when the user is on the holiday (apartamenty wakacyjne) listing view.
 * Use for conditional UI (e.g. hiding recent filters, different copy).
 */
export const useOfferListingHolidayView = (): boolean => {
    const investmentCategory = useSelector((state: IRPStore) => state.investmentOffer?.categories?.category);
    return investmentCategory === InvestmentOfferTypeSlug.HOLIDAY;
};
